const summary = [
  {
    name: 'RN之插件化',
    file: './articles/rn/RN.md'
  },
  {
    name: 'Kotlin的应用',
    file: './articles/kotlin/kotlin.md',
    shownInHomePage: true
  }
]

export default summary



// WEBPACK FOOTER //
// ./src/articles/summary.js